module.exports = __webpack_public_path__ + "13fcf8114b424a9b1f9285ce36b91baf.pdf";